<template>
  <div class="interview-editor">
    <el-form ref="form" label-width="100px">
      <el-form-item label="上边距">
        <el-slider v-model="currentItem.style.margin_top" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左右边距">
        <el-slider v-model="currentItem.style.padding" style="padding-left:10px;"></el-slider>
      </el-form-item>
      <el-form-item label="左标题">
        <el-input v-model="currentItem.title_left" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="右标题">
        <el-input v-model="currentItem.title_right" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="头像方向">
        <el-radio v-model="currentItem.direction" label="left">左侧</el-radio>
        <el-radio v-model="currentItem.direction" label="right">右侧</el-radio>
      </el-form-item>
      <el-form-item label="头像">
        <div class="image">
          <div class="add-btn" v-if="!currentItem.headimg" @click="selectThumb">+</div>
          <img v-if="currentItem.headimg" title="点击更换" :src="currentItem.headimg" @click="selectThumb"/>
        </div>
      </el-form-item>
      <el-form-item label="名称">
        <el-input v-model="currentItem.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="内容">
        <div class="content" v-for="(item,index) in currentItem.modules" :key="index">
          <template v-if="item.type==='text'">
            <el-input type="textarea":autosize="{ minRows: 2}" v-model="item.text" placeholder="请输入"></el-input>
          </template>
          <template v-if="item.type==='image'">
            <div class="image">
              <div class="add-btn" v-if="!item.image" @click="selectThumb2(index)">+</div>
              <img v-if="item.image" title="点击更换" :src="item.image" @click="selectThumb2(index)"/>
            </div>
            <el-input type="textarea":autosize="{ minRows: 2}" v-model="item.description" placeholder="请输入"></el-input>
          </template>
          <div class="btn-g">
            <el-button type="text" size="mini" @click="deleteItem(index)">删除</el-button>
          </div>
        </div>
        <div class="btn">
          <el-button size="mini" @click="handlePlusText">+ 文字</el-button>
          <el-button size="mini" @click="handlePlusImage">+ 图片</el-button>
        </div>
      </el-form-item>
    </el-form>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
import UploadImg from '@/components/UploadImg'
export default {
  name: 'interviewEditor',
  components: {
    UploadImg
  },
  computed: {
    currentItem () {
      return this.$store.state.page.currentItem
    }
  },
  methods: {
    handlePlusImage() {
      this.currentItem.modules.push({
        type: 'image',
        description: '',
        image: ''
      })
    },
    handlePlusText() {
      this.currentItem.modules.push({
        type: 'text',
        text: ''
      })
    },
    deleteItem(index) {
      this.currentItem.modules.splice(index, 1)
    },
    selectThumb () {
      let list = []
      if (this.currentItem.headimg) {
        list = [this.currentItem.headimg]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.currentItem.headimg = res[0]
        }
      }).catch()
    },
    selectThumb2(index) {
      let list = []
      if (this.currentItem.modules[index].image) {
        list = [this.currentItem.modules[index].image]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.currentItem.modules[index].image = res[0]
        }
      }).catch()
    }
  }
}
</script>
<style lang="less" scoped>
.interview-editor {
  .image {
    .add-btn {
      cursor: pointer;
      text-align: center;
      line-height: 50px;
      width: 50px;
      height: 50px;
      border: 1px dashed #cccccc;
    }
    img {
      cursor: pointer;
      height: 50px;
      width: auto;
    }
  }
  .content {
    padding: 8px 0;
    border-bottom: 1px dashed #dddddd;
    .image {
      margin-bottom: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageEditor/editors/interviewEditor.vue